import { useState } from 'react';
import { X } from 'lucide-react';
import { getCloudinaryUrl } from '../utils/cloudinary';
import { PageHeader } from './PageHeader';

const galleryImages = [
    'band-northwoods-1.jpg',
    'band-northwoods-2.jpg',
    'band-northwoods-3.jpg',
    'after-party-1.jpg',
    'live-1.jpg',
    'live-2.jpg',
    'live-3.jpg',
    'live-4.jpg',
    'live-5.jpg',
    'live-6.jpg',
    'live-7.jpg',
    'live-8.jpg',
    'live-9.jpg',
    'live-10.jpg',
    'live-11.jpg',
    'live-12.jpg',
];

export function MediaPage() {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    return (
        <div className="w-full py-12">
            <PageHeader title="Media" />

            {/* Gallery Grid */}
            <div className="max-w-6xl mx-auto px-4 pb-12">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {galleryImages.map((image, index) => (
                        <button
                            key={index}
                            onClick={() => setSelectedImage(image)}
                            className="group relative overflow-hidden rounded-lg cursor-pointer transition-transform hover:scale-105"
                        >
                            <img
                                src={getCloudinaryUrl(image, {
                                    width: 600,
                                    height: 400,
                                    crop: 'fill',
                                    quality: 'auto',
                                })}
                                alt={`Gallery ${index + 1}`}
                                className="w-full h-64 object-cover transition-transform group-hover:scale-110"
                                loading="lazy"
                            />
                            {/* Overlay on hover */}
                            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <span className="text-white text-sm font-semibold">View</span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {/* Lightbox Modal */}
            {selectedImage && (
                <div
                    className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
                    onClick={() => setSelectedImage(null)}
                >
                    <button
                        onClick={() => setSelectedImage(null)}
                        className="absolute top-6 right-6 text-white hover:text-primary transition-colors"
                        aria-label="Close lightbox"
                    >
                        <X className="w-8 h-8" />
                    </button>

                    <img
                        src={getCloudinaryUrl(selectedImage, { width: 2000, quality: 'auto' })}
                        alt="Full size"
                        className="max-w-4xl max-h-[80vh] object-contain"
                        onClick={(e) => e.stopPropagation()}
                    />

                    {/* Navigation */}
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white text-sm">
                        {galleryImages.indexOf(selectedImage) + 1} / {galleryImages.length}
                    </div>
                </div>
            )}
        </div>
    );
}
